import { Component, defineComponent, onMounted, onUnmounted } from 'vue';
import ModalCode from '@/presentation/components/modal/modal-class';
import MainContent from '@/presentation/components/main-content/main-content.vue';

export default defineComponent({
	components: {
		MainContent: MainContent as Component
	},
	setup: () => {
		const code = new ModalCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			modalContent: code.modalContent,
			closeModal: code.closeModal.bind(code)
		};
	}
});
